// extracted by mini-css-extract-plugin
export default {"customersWrapper":"customersField_customersWrapper__FyJtt","fieldsWrapper":"customersField_fieldsWrapper__L1N1C"};